export const COMPOSE_EMAIL = 'COMPOSE_EMAIL';
export const MAXIMIZE_COMPOSE_MODAL = 'MAXIMIZE_COMPOSE_MODAL';
export const MINIMIZE_COMPOSE_MODAL = 'MINIMIZE_COMPOSE_MODAL';
